/**
 * The active language, readable without importing the whole i18n stack -- the
 * mutator needs it on every request and must not depend on React.
 * P0-28 wires i18next to keep this in step.
 */
let current: "en" | "fr" = "en"

export const currentLanguage = (): "en" | "fr" => current
export const setCurrentLanguage = (lang: "en" | "fr"): void => {
  current = lang
}
